import React from 'react';
import '../App.css';
import {Availability} from "../containers/Availability";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {pink400, pink600} from 'material-ui/styles/colors';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import * as AppDimensions from '../constants/AppDimensions';

// This replaces the textColor value on the palette
// and then update the keys for each component that depends on it.
// More on Colors: http://www.material-ui.com/#/customization/colors
const muiTheme = getMuiTheme({
  palette: {
    primary1Color: pink400,
    primary2Color: pink600,
    pickerHeaderColor: pink400,
  }
});

const minWidth = AppDimensions.minWidth;
const maxWidth = AppDimensions.maxWidth;

class AppComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: maxWidth,
    };

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  /**
   * Calculate & Update state of new dimensions
   */
  updateDimensions() {

    if(window.innerWidth < maxWidth) {
      this.props.onDisplayNoOfNightsChange(7)
    }
    else {
      this.props.onDisplayNoOfNightsChange(14)
    }

    if(window.innerWidth > maxWidth) {
      this.setState({width: maxWidth });
    } else if(window.innerWidth < minWidth) {
      this.setState({width: minWidth-100});
    } else {
      let update_width  = window.innerWidth-100;
      this.setState({width: update_width});
    }
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    return (
        <div className="availNow" style={{width: this.state.width}}>
          <div>
            <MuiThemeProvider muiTheme={getMuiTheme(this.props.muiTheme)}>
              <Availability />
            </MuiThemeProvider>
          </div>
        </div>
    );
  }
}

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/AppComponent.js